<div class="waiting">
  <mh-spinner-classic [hidden]="!waiting"></mh-spinner-classic>
</div>

<div class="tables-result" *ngIf="!waiting">
  <div *ngFor="let factor of ['brands','regions']" class="{{factor}}">
    <mh-box-element [title]="('inter-chain.executive.table.'+factor | translate)">
      <mh-executive-table
        [areaSelected]="filterSelected['areas']"
        [totals]="totals[factor]"
        [factor]="factor"
        [currentYear]="currentYear"
        [previousYear]="previousYear"
        [selected]="filterSelected['metrics']"
        [dataSource]="(factor === 'brands' ? dataSourceBrands : dataSourceRegions)"
      ></mh-executive-table>
    </mh-box-element>
  </div>
</div>

